/* AsPadel — filtres de collection : tiroir plein écran mobile, compteur en direct, mise à jour de la grille sans rechargement. */
(function () {
  'use strict';
  if (window.__apFil) return; window.__apFil = true;

  function Filtres(racine) {
    this.racine = racine;
    this.url = racine.getAttribute('data-url') || window.location.pathname;
    /* La grille porte son identifiant de section complet, du type
       template--123__grille. C'est lui que l'API de rendu de Shopify attend,
       et lui qu'il faut pour retrouver l'element : on le lit sur la grille
       plutot que de le deviner a partir de la cle courte. */
    var cle = racine.getAttribute('data-grille') || 'grille';
    this.grille = document.querySelector('[data-grille-section$="' + cle + '"]') || document.querySelector('[data-grille-section]');
    this.grilleId = this.grille ? this.grille.getAttribute('data-grille-section') : cle;
    this.form = racine.querySelector('[data-filtres-form]');
    this.tiroir = racine.querySelector('[data-tiroir]');
    this.fond = racine.querySelector('[data-fond]');
    this.ouvrir = racine.querySelector('[data-ouvrir]');
    this.tri = racine.querySelector('[data-tri]');
    this.triCache = racine.querySelector('[data-tri-cache]');
    this.badge = racine.querySelector('[data-badge]');
    this.compteTiroir = racine.querySelector('[data-compte-tiroir]');
    this.timer = null;
    this.controleur = null;
    this.lier();
  }

  Filtres.prototype.lier = function () {
    var self = this;
    if (this.ouvrir) this.ouvrir.addEventListener('click', function () { self.ouvrirTiroir(); });
    this.racine.querySelectorAll('[data-fermer]').forEach(function (b) { b.addEventListener('click', function () { self.fermerTiroir(); }); });
    if (this.fond) this.fond.addEventListener('click', function () { self.fermerTiroir(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && self.tiroir && !self.tiroir.hidden) self.fermerTiroir(); });
    if (this.form) {
      this.form.addEventListener('change', function () { self.planifier(); });
      this.form.addEventListener('input', function (e) { if (e.target.type === 'number') self.planifier(400); });
      this.form.addEventListener('submit', function (e) {
        /* Sans grille reperee, on laisse le navigateur soumettre le formulaire :
           mieux vaut un rechargement complet qu'un bouton qui ne fait rien. */
        if (!self.grille) return;
        e.preventDefault();
        try {
          self.fermerTiroir();
          self.charger(true);
        } catch (err) {
          /* Dernier filet : on part sur la page filtree plutot que de laisser
             le visiteur devant un bouton inerte. */
          document.documentElement.classList.remove('ap-tiroir-ouvert');
          window.location.href = self.url + '?' + self.parametres().toString();
        }
      });
    }
    if (this.tri) this.tri.addEventListener('change', function () {
      if (self.triCache) self.triCache.value = self.tri.value;
      self.charger(true);
    });
    var reinit = this.racine.querySelector('[data-reinitialiser]');
    if (reinit) reinit.addEventListener('click', function (e) {
      e.preventDefault();
      self.form.querySelectorAll('input[type=checkbox]').forEach(function (c) { c.checked = false; });
      self.form.querySelectorAll('input[type=number]').forEach(function (c) { c.value = ''; });
      self.charger(true);
    });
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-filtre-lien]');
      if (!a || !self.grille || !self.grille.contains(a)) return;
      e.preventDefault();
      self.appliquerUrl(a.getAttribute('href'));
    });
  };

  Filtres.prototype.ouvrirTiroir = function () {
    if (!this.tiroir) return;
    this.tiroir.hidden = false;
    if (this.fond) this.fond.hidden = false;
    this.ouvrir.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('ap-tiroir-ouvert');
    this.dernierFocus = document.activeElement;
    var premier = this.tiroir.querySelector('input:not([disabled]), button, a');
    if (premier) premier.focus();
    this.piegeFocus = this.piegeFocus || this.pieger.bind(this);
    this.tiroir.addEventListener('keydown', this.piegeFocus);
  };

  Filtres.prototype.fermerTiroir = function () {
    /* Le verrou de defilement part en premier : meme si la suite echoue,
       le visiteur ne reste jamais prisonnier de la page. */
    document.documentElement.classList.remove('ap-tiroir-ouvert');
    if (!this.tiroir || this.tiroir.hidden) return;
    this.tiroir.hidden = true;
    if (this.fond) this.fond.hidden = true;
    if (this.ouvrir) this.ouvrir.setAttribute('aria-expanded', 'false');
    if (this.piegeFocus) this.tiroir.removeEventListener('keydown', this.piegeFocus);
    if (this.dernierFocus && this.dernierFocus.focus) this.dernierFocus.focus();
  };

  Filtres.prototype.pieger = function (e) {
    if (e.key !== 'Tab') return;
    var f = this.tiroir.querySelectorAll('input:not([disabled]), button:not([disabled]), a[href], select');
    if (!f.length) return;
    var premier = f[0], dernier = f[f.length - 1];
    if (e.shiftKey && document.activeElement === premier) { e.preventDefault(); dernier.focus(); }
    else if (!e.shiftKey && document.activeElement === dernier) { e.preventDefault(); premier.focus(); }
  };

  Filtres.prototype.planifier = function (delai) {
    var self = this;
    clearTimeout(this.timer);
    this.timer = setTimeout(function () { self.charger(false); }, delai || 150);
  };

  Filtres.prototype.parametres = function () {
    var p = new URLSearchParams();
    if (!this.form) return p;
    new FormData(this.form).forEach(function (v, k) { if (String(v).trim() !== '') p.append(k, v); });
    return p;
  };

  Filtres.prototype.appliquerUrl = function (href) {
    var u = new URL(href, window.location.origin);
    this.synchroniserForm(u.searchParams);
    this.charger(true);
  };

  Filtres.prototype.synchroniserForm = function (params) {
    if (!this.form) return;
    this.form.querySelectorAll('input[type=checkbox]').forEach(function (c) {
      c.checked = params.getAll(c.name).indexOf(c.value) !== -1;
    });
    this.form.querySelectorAll('input[type=number]').forEach(function (c) { c.value = params.get(c.name) || ''; });
  };

  /* Charge la grille et les compteurs de facettes en un seul appel (sections=…) */
  Filtres.prototype.charger = function (remplacer) {
    var self = this;
    /* Un rafraichissement differe peut encore etre en attente : on l'annule,
       sinon il se declenche apres coup et abandonne la requete en cours. */
    clearTimeout(this.timer);
    var params = this.parametres();
    var filtresId = this.racine.getAttribute('data-filtres-id');
    var url = this.url + '?' + params.toString() + '&sections=' + encodeURIComponent(this.grilleId + ',' + filtresId);
    if (this.controleur) this.controleur.abort();
    this.controleur = new AbortController();
    this.racine.classList.add('est-en-cours');
    if (this.grille) this.grille.setAttribute('aria-busy', 'true');
    fetch(url, { signal: this.controleur.signal })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        var parser = new DOMParser();
        var docGrille = parser.parseFromString(json[self.grilleId] || '', 'text/html');
        var docFiltres = parser.parseFromString(json[filtresId] || '', 'text/html');
        var compte = docGrille.querySelector('[data-compte]');
        var n = compte ? Number(compte.getAttribute('data-count')) : null;
        if (n !== null && self.compteTiroir) self.compteTiroir.textContent = n;
        var voir = self.racine.querySelector('[data-voir]');
        if (voir && n !== null) {
          /* Les mots viennent des reglages de la section, pas du script. */
          var un = voir.getAttribute('data-mot-un') || 'pala';
          var plusieurs = voir.getAttribute('data-mot-plusieurs') || 'palas';
          voir.lastChild.textContent = ' ' + (n === 1 ? un : plusieurs);
        }
        docFiltres.querySelectorAll('[data-facet-count]').forEach(function (span) {
          var cle = span.getAttribute('data-facet-count');
          var local = self.racine.querySelector('[data-facet-count="' + cle.replace(/"/g, '\\"') + '"]');
          if (local) {
            local.textContent = span.textContent;
            var input = local.closest('label') && local.closest('label').querySelector('input');
            var zero = span.textContent.replace(/\D/g, '') === '0';
            if (input && !input.checked) { input.disabled = zero; local.closest('label').classList.toggle('ap-case--vide', zero); }
          }
        });
        var nbActifs = 0;
        self.form.querySelectorAll('input[type=checkbox]:checked').forEach(function () { nbActifs++; });
        self.form.querySelectorAll('input[type=number]').forEach(function (i) { if (i.value !== '') nbActifs++; });
        self.majBadge(nbActifs);
        if (remplacer || window.matchMedia('(min-width: 990px)').matches) {
          var nouvelle = docGrille.querySelector('[data-grille-section]');
          if (nouvelle && self.grille) {
            self.grille.innerHTML = nouvelle.innerHTML;
            var tri = self.tri ? self.tri.value : '';
            if (window.aspadelTrier && (!tri || tri === 'manual' || tri === 'best-selling')) window.aspadelTrier();
          }
          var propre = new URL(window.location.href);
          propre.search = params.toString();
          window.history.replaceState({}, '', propre.toString());
        }
      })
      .catch(function (err) { if (err.name !== 'AbortError') window.location.href = self.url + '?' + params.toString(); })
      .finally(function () {
        self.racine.classList.remove('est-en-cours');
        if (self.grille) self.grille.removeAttribute('aria-busy');
      });
  };

  Filtres.prototype.majBadge = function (n) {
    if (!this.ouvrir) return;
    var b = this.ouvrir.querySelector('[data-badge]');
    if (n > 0) {
      if (!b) { b = document.createElement('span'); b.className = 'ap-filtres__badge ap-num'; b.setAttribute('data-badge', ''); this.ouvrir.appendChild(document.createTextNode(' ')); this.ouvrir.appendChild(b); }
      b.textContent = n;
    } else if (b) { b.remove(); }
  };

  function init() { document.querySelectorAll('[data-filtres]').forEach(function (el) { new Filtres(el); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
